import React, { createContext, useState } from 'react';
import { FormValues } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';

type ProductStepContextType = {
  isUpdatingTankInfo: boolean;
  field: { name: string; newValue: any; currentValue: any } | null;
  update: (
    state: Pick<ProductStepContextType, 'isUpdatingTankInfo' | 'field'>
  ) => void;
  recentlyUpdated: {
    fields: Array<keyof FormValues>;
    products: Record<string, string[]>;
  };
  setRecentlyUpdated: any;
};

const ProductStepContext = createContext<ProductStepContextType>({
  isUpdatingTankInfo: false,
  field: null,
  update: () => ({
    isUpdatingTankInfo: false,
    field: null
  }),
  recentlyUpdated: { fields: [], products: {} },
  setRecentlyUpdated: () => {}
});

export const ProductStepProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [recentlyUpdated, setRecentlyUpdated] = useState<
    ProductStepContextType['recentlyUpdated']
  >({ fields: [], products: {} });
  const [state, setState] = useState<
    Pick<ProductStepContextType, 'isUpdatingTankInfo' | 'field'>
  >({
    isUpdatingTankInfo: false,
    field: null
  });

  const update = ({
    isUpdatingTankInfo,
    field
  }: Pick<ProductStepContextType, 'isUpdatingTankInfo' | 'field'>) => {
    setState({ isUpdatingTankInfo, field });
  };

  const contextValue = React.useMemo(
    () => ({
      ...state,
      update,
      recentlyUpdated,
      setRecentlyUpdated
    }),
    [state, recentlyUpdated, setRecentlyUpdated]
  );

  return (
    <ProductStepContext.Provider value={contextValue}>
      {children}
    </ProductStepContext.Provider>
  );
};

export const useProductStep = () => React.useContext(ProductStepContext);
